import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';

const StyledTextArea = styled.textarea<{ resizable: boolean }>(({ resizable }) => {
  return css`
    width: 100%;
    min-height: ${props => props.theme.components['text-area']['min-height']};
    padding: ${props => props.theme.components['text-area'].padding};
    ${!resizable &&
    css`
      resize: none;
    `}
  `;
});

StyledTextArea.defaultProps = defaultThemeProp;

export default StyledTextArea;
